module.exports = __webpack_public_path__ + "img/domshenko.1991cace.jpg";